export const PERSONAL_TASK_COLOR = '#7C3AED';
export const DEFAULT_WORK_TASK_COLOR = '#4CAF50';

export function isPersonalTask(task) {
  return task?.is_personal === true || task?.is_personal === 'true';
}

export function normalizeTaskKindPayload(data = {}) {
  const payload = { ...data };
  payload.is_personal = isPersonalTask(payload);

  if (!payload.is_personal) return payload;

  payload.client_id = null;
  payload.object_id = null;
  payload.cost = 0;
  payload.category = 'personal';
  payload.color = PERSONAL_TASK_COLOR;
  payload.carry_items = [];

  // Старые расходы остаются в финансовой истории. Личная форма их не
  // редактирует и не должна случайно удалять при обычном сохранении.
  delete payload.expenses;

  return payload;
}
